import React from 'react';
import styled from 'styled-components';
import DecorativeElement from './DecorativeElement';
import { colors } from '../../styles/colors';

const DecoratedSection = styled.section`
  position: relative;
  overflow: hidden;
  ${props => props.customStyles}
`;

const SectionDecorator = ({
    children,
    theme = 'light',
    density = 'medium',
    customStyles = '',
    className = ''
}) => {
    const getDecorations = () => {
        const baseColor = theme === 'light' ? colors.primary : colors.white;
        const accentColor = theme === 'light' ? colors.accent : colors.accent;

        const decorations = {
            sparse: [
                {
                    type: 'leafPattern',
                    position: { top: '50px', left: '-50px' },
                    width: '200px',
                    height: '200px',
                    fill: baseColor,
                    opacity: 0.05,
                    rotate: 45
                },
                {
                    type: 'dots',
                    position: { bottom: '100px', right: '-30px' },
                    width: '150px',
                    height: '150px',
                    fill: accentColor,
                    opacity: 0.05
                }
            ],
            medium: [
                {
                    type: 'leafPattern',
                    position: { top: '50px', left: '-50px' },
                    width: '200px',
                    height: '200px',
                    fill: baseColor,
                    opacity: 0.05,
                    rotate: 45
                },
                {
                    type: 'dots',
                    position: { top: '30%', right: '-30px' },
                    width: '150px',
                    height: '150px',
                    fill: accentColor,
                    opacity: 0.05
                },
                {
                    type: 'wavyLine',
                    position: { bottom: '100px', right: '50px' },
                    width: '120px',
                    height: '300px',
                    fill: baseColor,
                    opacity: 0.07,
                    rotate: 180
                },
                {
                    type: 'abstractShape',
                    position: { bottom: '-50px', left: '10%' },
                    width: '150px',
                    height: '150px',
                    fill: accentColor,
                    opacity: 0.05
                }
            ],
            dense: [
                {
                    type: 'leafPattern',
                    position: { top: '50px', left: '-50px' },
                    width: '200px',
                    height: '200px',
                    fill: baseColor,
                    opacity: 0.05,
                    rotate: 45
                },
                {
                    type: 'dots',
                    position: { top: '20%', right: '-30px' },
                    width: '150px',
                    height: '150px',
                    fill: accentColor,
                    opacity: 0.05
                },
                {
                    type: 'wavyLine',
                    position: { top: '40%', left: '-20px' },
                    width: '120px',
                    height: '300px',
                    fill: baseColor,
                    opacity: 0.07
                },
                {
                    type: 'abstractShape',
                    position: { bottom: '-50px', left: '10%' },
                    width: '150px',
                    height: '150px',
                    fill: accentColor,
                    opacity: 0.05
                },
                {
                    type: 'dots',
                    position: { bottom: '30%', right: '10%' },
                    width: '100px',
                    height: '100px',
                    fill: baseColor,
                    opacity: 0.05
                },
                {
                    type: 'leafPattern',
                    position: { top: '60%', right: '15%' },
                    width: '120px',
                    height: '120px',
                    fill: accentColor,
                    opacity: 0.03,
                    rotate: -30
                }
            ]
        };

        return decorations[density] || decorations.medium;
    };

    return (
        <DecoratedSection customStyles={customStyles} className={className}>
            {getDecorations().map((decoration, index) => (
                <DecorativeElement key={index} {...decoration} />
            ))}
            {children}
        </DecoratedSection>
    );
};

export default SectionDecorator; 